import { Suspense, lazy } from "react";
// import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/profile/main"));

const Profile = () => {
  return (
    <Layout pageHeading="Profile">
      <Suspense>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default Profile;
